// extracted by mini-css-extract-plugin
export default {"section":"IconLibrary_section__9nKdl"};